import { createAction, props } from '@ngrx/store';
import { ErrorResponse, IGenericError } from 'src/app/core/models/generic-models';
import { IBusinessFicaUploadedFileResponse } from '../models/business-fica-files.model';

export const loadBusinessFicaFiles = createAction('[BusinessFicaFile] Load BusinessFicaFiles', props<{ businessId: string }>());

export const loadBusinessFicaFilesSuccess = createAction(
  '[BusinessFicaFile] Load BusinessFicaFiles Success',
  props<{ response: IBusinessFicaUploadedFileResponse[] }>()
);

export const loadBusinessFicaFilesFailure = createAction(
  '[BusinessFicaFile] Load BusinessFicaFiles Failure',
  props<{ error: IGenericError<ErrorResponse> }>()
);
